import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';

import { seek } from 'src/common/actions/player';

import Slider from './Slider';
import css from './scrubber.module.scss';

export class LiveSeekScrubber extends Component {
  static propTypes = {
    canScrub: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    sliderMax: PropTypes.number.isRequired,
    elapsedTime: PropTypes.string.isRequired,
    elapsedPercent: PropTypes.number.isRequired,
    elapsedSeconds: PropTypes.number.isRequired,
    onChangeCommitted: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    if (event) event.preventDefault();
    this.props.actions.seek(100);
  }

  render() {
    const {
      canScrub,
      sliderMax,
      elapsedTime,
      elapsedPercent,
      elapsedSeconds,
      onChangeCommitted,
    } = this.props;

    const isNotLive = elapsedPercent < 100;

    return (
      <div data-testid="scrubberWrapper">
        <div className={css.elapsed} data-testid="elapsedWrapper">
          <span data-elapsedtime={elapsedSeconds} id="scrubberElapsed">
            {elapsedTime}
          </span>
        </div>
        <Slider
          canScrub={canScrub}
          isDisabled={false}
          elapsedPercent={elapsedPercent}
          sliderMax={sliderMax}
          onChangeCommitted={onChangeCommitted}
        />
        {isNotLive ? (
          <div
            id="goLiveButton"
            data-testid="goLiveButton"
            className={classNames(css.liveSeekTextContainer, css.goLiveButton)}
            onClick={this.onClick}
          >
            GO LIVE
          </div>
        ) : (
          <div
            id="scrubberDuration"
            className={classNames(css.liveSeekTextContainer, css.liveSeekText)}
          >
            LIVE
          </div>
        )}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      seek: (percentage) => dispatch(seek(percentage)),
    },
  };
}

export default connect(null, mapDispatchToProps)(LiveSeekScrubber);
